import { render, staticRenderFns } from "./LayoutElementTypeText.vue?vue&type=template&id=107c8648&scoped=true"
import script from "./LayoutElementTypeText.vue?vue&type=script&lang=js"
export * from "./LayoutElementTypeText.vue?vue&type=script&lang=js"
import style0 from "./LayoutElementTypeText.vue?vue&type=style&index=0&id=107c8648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107c8648",
  null
  
)

export default component.exports